module.exports = __webpack_public_path__ + "static/media/uvr_logo.ebdc5988.svg";